export const IMPRESSIONS_SET = 'IMPRESSIONS_SET'
export const SITE_VIEWS_SET = 'SITE_VIEWS_SET'
export const TOP_SAVED_PRODUCTS_GOT = 'TOP_SAVED_PRODUCTS_GOT'
export const TOP_SAVED_PRODUCTS_PENDING = 'TOP_SAVED_PRODUCTS_PENDING'
export const TOP_VIEWED_PRODUCTS_GOT = 'TOP_VIEWED_PRODUCTS_GOT'
export const TOP_VIEWED_PRODUCTS_PENDING = 'TOP_VIEWED_PRODUCTS_PENDING'
export const TOTAL_PRODUCT_DATA_PENDING = 'TOTAL_PRODUCT_DATA_PENDING'
export const TOTAL_PRODUCT_DATA_SET = 'TOTAL_PRODUCT_DATA_SET'
export const TOTAL_SALES_SET = 'TOTAL_SALES_SET'
